import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import t from "../Color.js";
import { clone as o } from "../core/lang.js";
import { aliasOf as r } from "../core/accessorSupport/decorators/aliasOf.js";
import "../core/accessorSupport/ensureType.js";
import { enumeration as i } from "../core/accessorSupport/decorators/enumeration.js";
import { property as s } from "../core/accessorSupport/decorators/property.js";
import { subclass as n } from "../core/accessorSupport/decorators/subclass.js";
import { collectArcadeFieldNames as l } from "../layers/support/fieldUtils.js";
import p from "./Renderer.js";
import { VisualVariablesMixin as a } from "./mixins/VisualVariablesMixin.js";
import u from "./support/AttributeColorInfo.js";
import d from "./support/DotDensityLegendOptions.js";
import c from "../symbols/SimpleFillSymbol.js";
import h from "../symbols/SimpleLineSymbol.js";

var _y;

var m = _y = /*#__PURE__*/function (_a) {
  _inherits(y, _a);

  var _super = _createSuper(y);

  function y(e) {
    var _this;

    _classCallCheck(this, y);

    _this = _super.call(this, e), _this.attributes = null, _this.backgroundColor = new t([0, 0, 0, 0]), _this.blendDots = !0, _this.dotBlendingEnabled = !0, _this.dotShape = "square", _this.dotSize = 1, _this.legendOptions = null, _this.outline = new h(), _this.dotValue = null, _this.referenceDotValue = null, _this.referenceScale = null, _this.seed = 1, _this.type = "dot-density";
    return _this;
  }

  _createClass(y, [{
    key: "calculateDotValue",
    value: function calculateDotValue(e) {
      if (null == this.referenceScale) return this.dotValue;
      var t = e / this.referenceScale * this.dotValue;
      return t < 1 ? 1 : t;
    }
  }, {
    key: "getSymbol",
    value: function getSymbol() {
      return new c({
        outline: this.outline
      });
    }
  }, {
    key: "getSymbolAsync",
    value: function () {
      var _getSymbolAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.getSymbol());

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getSymbolAsync() {
        return _getSymbolAsync.apply(this, arguments);
      }

      return getSymbolAsync;
    }()
  }, {
    key: "getSymbols",
    value: function getSymbols() {
      return [this.getSymbol()];
    }
  }, {
    key: "getAttributeHash",
    value: function getAttributeHash() {
      return this.attributes && this.attributes.reduce(function (e, t) {
        return e + t.getAttributeHash();
      }, "");
    }
  }, {
    key: "getMeshHash",
    value: function getMeshHash() {
      return JSON.stringify(this.outline);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _y({
        attributes: o(this.attributes),
        backgroundColor: o(this.backgroundColor),
        dotBlendingEnabled: o(this.dotBlendingEnabled),
        dotShape: o(this.dotShape),
        dotSize: o(this.dotSize),
        dotValue: o(this.dotValue),
        legendOptions: o(this.legendOptions),
        outline: o(this.outline),
        referenceScale: o(this.referenceScale),
        visualVariables: o(this.visualVariables),
        authoringInfo: this.authoringInfo && this.authoringInfo.clone()
      });
    }
  }, {
    key: "getControllerHash",
    value: function getControllerHash() {
      return "".concat(this.attributes.map(function (e) {
        return e.field || e.valueExpression || "";
      }), "-").concat(this.outline && JSON.stringify(this.outline.toJSON()) || "");
    }
  }, {
    key: "collectRequiredFields",
    value: function () {
      var _collectRequiredFields = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, t) {
        var _iterator, _step, _o;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.collectVVRequiredFields(e, t);

              case 2:
                _iterator = _createForOfIteratorHelper(this.attributes);
                _context2.prev = 3;

                _iterator.s();

              case 5:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 14;
                  break;
                }

                _o = _step.value;
                _context2.t0 = _o.valueExpression;

                if (!_context2.t0) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 11;
                return l(e, t, _o.valueExpression);

              case 11:
                _o.field && e.add(_o.field);

              case 12:
                _context2.next = 5;
                break;

              case 14:
                _context2.next = 19;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t1 = _context2["catch"](3);

                _iterator.e(_context2.t1);

              case 19:
                _context2.prev = 19;

                _iterator.f();

                return _context2.finish(19);

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 16, 19, 22]]);
      }));

      function collectRequiredFields(_x, _x2) {
        return _collectRequiredFields.apply(this, arguments);
      }

      return collectRequiredFields;
    }()
  }]);

  return y;
}(a(p));

e([s({
  type: [u],
  json: {
    write: !0
  }
})], m.prototype, "attributes", void 0), e([s({
  type: t,
  json: {
    write: !0
  }
})], m.prototype, "backgroundColor", void 0), e([s({
  type: Boolean
}), r("dotBlendingEnabled")], m.prototype, "blendDots", void 0), e([s({
  type: Boolean,
  json: {
    write: !0
  }
})], m.prototype, "dotBlendingEnabled", void 0), e([s({
  type: String,
  json: {
    write: !1
  }
})], m.prototype, "dotShape", void 0), e([s({
  type: Number,
  json: {
    write: !1
  }
})], m.prototype, "dotSize", void 0), e([s({
  type: d,
  json: {
    write: !0
  }
})], m.prototype, "legendOptions", void 0), e([s({
  type: h,
  json: {
    default: null,
    write: !0
  }
})], m.prototype, "outline", void 0), e([s({
  type: Number,
  json: {
    write: !0
  }
})], m.prototype, "dotValue", void 0), e([s({
  type: Number
}), r("dotValue")], m.prototype, "referenceDotValue", void 0), e([s({
  type: Number,
  json: {
    write: !0
  }
})], m.prototype, "referenceScale", void 0), e([s({
  type: Number,
  json: {
    write: !0
  }
})], m.prototype, "seed", void 0), e([i({
  dotDensity: "dot-density"
})], m.prototype, "type", void 0), m = _y = e([n("esri.renderers.DotDensityRenderer")], m);
var b = m;
export { b as default };